import { getStoreAccessors } from 'typesafe-vuex';
import { AdminState } from '../state';
import { State } from '@/store/state';
import { getters } from '../getters';

const { read } = getStoreAccessors<AdminState, State>('');

export const readAdminOneUser = read(getters.adminOneUser);
export const readAdminUsers = read(getters.adminUsers);
export const readOneService = read(getters.oneService);
export const readServices = read(getters.services);
export const readSenderBans = read(getters.moSenderBans);
export const readSettings = read(getters.settings);
